import { getFirstContentTypeTag } from '../../../scripts/utils/tags-utils.js';

function getArticleTagLabel(articleData, tags) {
  return getFirstContentTypeTag(articleData.cqTags, tags)?.label || '';
}

export default getArticleTagLabel;
